import { useAlertHistory } from "@/hooks/use-alerts";
import type { AlertInstance } from "@/lib/types";

export function AlertHistory() {
  const { data: alerts, isLoading } = useAlertHistory();

  if (isLoading) return <p className="text-[12px] text-[var(--iris-fg-3)]">Loading…</p>;

  return (
    <div className="overflow-hidden rounded-[16px] border border-white/[0.055] bg-[var(--iris-bg-2)]">
      <div className="grid grid-cols-[40px_2fr_1fr_100px_100px] gap-1 border-b border-white/[0.04] px-[18px] py-3 text-[11px] text-[var(--iris-fg-4)]">
        <span>Sev</span>
        <span>Alert</span>
        <span>Source</span>
        <span>Fired</span>
        <span>Resolved</span>
      </div>
      {(alerts ?? []).map((a: AlertInstance) => (
        <div
          key={a.id}
          className="grid grid-cols-[40px_2fr_1fr_100px_100px] items-center gap-1 border-b border-white/[0.04] px-[18px] py-3 text-[12px] last:border-0"
        >
          <span
            className={`h-[10px] w-[10px] rounded-full ${
              a.severity === "critical"
                ? "bg-[var(--iris-neon-pink)]"
                : "bg-[var(--iris-neon-orange)]"
            }`}
          />
          <span className="text-[var(--iris-fg-3)]">{a.message}</span>
          <span className="text-[var(--iris-fg-3)]">{a.source}</span>
          <span className="text-[var(--iris-fg-4)]">{a.fired_at?.slice(0, 16)}</span>
          <span className="text-[var(--iris-fg-4)]">{a.resolved_at?.slice(0, 16)}</span>
        </div>
      ))}
    </div>
  );
}
